<template>
  <form class="w rs-form">
    <div class="rs-form--row">
      <label for="tel"
        ><span>您的手机号&nbsp;</span><i>*</i>&nbsp;
        <span class="error" v-if="errorTELText">&nbsp;{{ errorTELText }}</span>
        <!-- <span class="error">&nbsp;请输入手机号码，便于我们与您联系</span> -->
      </label>
      <!-- <input
        type="number"
        oninput="if(value.length > 11) value = value.slice(0,11)"
        maxlength="11"
        v-model="mobile"
        autocomplete="false"
        name="tel"
        @blur="setTel"
        @keyup="clearErrTELTxt"
        placeholder="请填写您的手机号"
      /> -->
      <input
        oninput="if(value.length > 11) value = value.slice(0,11)"
        maxlength="11"
        v-model="mobile"
        autocomplete="false"
        name="tel"
        @blur="setTel"
        @keyup="clearErrTELTxt"
        placeholder="请填写您的手机号"
      />
    </div>
    <div class="rs-form--row">
      <label>您的预产期&nbsp;<i>*</i></label>
      <div class="due-group">
        <span
          class="due-item"
          v-for="(due, index) in dueDates"
          :key="index"
          :class="{ on: due === selDue }"
          @click="setDue(due)"
          >{{ due }}</span
        >
      </div>
    </div>
    <div class="rs-form--row line3">
      <label for="content"
        >详细诉求&nbsp;<span class="note">(选填)</span></label
      >
      <textarea
        v-model="content"
        name="content"
        maxlength="200"
        :placeholder="remarkPlaceholder"
        class="rs-form--content"
        @blur="setContent"
      />
    </div>
    <slot name="button">
      <button type="submit" class="rs-form--submit" @click="submit">
        <span style="flex: 1">提交需求</span>
      </button>
    </slot>
    <!--置最后，不遮挡点击-->
    <img
      class="close-icon"
      @click="$emit('handleClose')"
      src="../../../assets/images/home/icon-删除-弹窗@3x.png"
    />
  </form>
</template>
<script>
import { STORAGENAME_RQ, getDueDates, getUserInfoApi } from './service'
import { isEmptyObject, isNullOrEmpty } from '@/utils'
import fetch from '@/plugins/fetch'
import Cookie from 'js-cookie'
import changePrivinceCodeToCityCode from '@/plugins/changeCityCode'
import queryString from 'query-string'
import { Indicator } from 'mint-ui'
import { PREFIX_SVSACTIVITY_API } from '@/service'
import { CLUE_CATEGORY, CLUE_SOURE } from '@/config/YuesaoConfig'

const storage = localStorage
const dueDates = getDueDates()

export default {
  props: {
    cityAndLocationInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      cityName: '南京',
      cityCode: '',
      content: '',
      mobile: '',
      maskMobile: '', // 用户手机号掩码
      remarkPlaceholder: '详细描述有助于我们更好的为您定制服务哦',
      dueDates,
      selDue: dueDates[1],
      lockHttp: false,
      latitude: '',
      longitude: '',
      curDistrictId: '',
      curCityCode: '',
      errorTELText: ''
    }
  },
  async created() {
    await this.getUserInfo()
    this.getLat()
    this.setCityInfo()

    const due = storage.getItem(STORAGENAME_RQ.DUE)
    if (due) {
      this.selDue = due
    }
    const tel = storage.getItem(STORAGENAME_RQ.TEL)
    if (tel) {
      this.mobile = tel
    }
    const remark = storage.getItem(STORAGENAME_RQ.REMARK)
    if (remark) {
      this.content = remark
    }
  },
  methods: {
    clearErrTELTxt() {
      this.errorTELText = ''
    },
    setContent(e) {
      storage.setItem(STORAGENAME_RQ.REMARK, this.content)
      this.reScroll(e)
    },
    setTel(e) {
      storage.setItem(STORAGENAME_RQ.TEL, this.mobile)
      this.reScroll(e)
    },
    setDue(due) {
      this.selDue = due
      storage.setItem(STORAGENAME_RQ.DUE, due)
    },
    async setCityInfo() {
      let cityInfo = this.defaultCityInfo
      this._setCityInfo(cityInfo)
    },
    _setCityInfo(obj) {
      if (!isNullOrEmpty(obj) && !isEmptyObject(obj)) {
        this.cityName = obj.cityName
        this.cityCode = changePrivinceCodeToCityCode(obj.cityCode)
        this.cityCode = ''
      }
    },
    reScroll(e) {
      e && e.target && e.target.scrollIntoView()
    },
    removePersistenceItem() {
      storage.removeItem(STORAGENAME_RQ.DUE)
      storage.removeItem(STORAGENAME_RQ.TEL)
      storage.removeItem(STORAGENAME_RQ.REMARK)
    },
    async getLat() {
      this.cityName = this.cityAndLocationInfo.cityName
      this.cityCode = this.cityAndLocationInfo.cityCode
      this.curDistrictId = this.cityAndLocationInfo.areaCode || ''
      this.latitude = this.cityAndLocationInfo.lat || ''
      this.longitude = this.cityAndLocationInfo.lng || ''
      this.curCityCode = this.cityAndLocationInfo.curCityId || ''
    },
    async submit(e) {
      e.preventDefault()
      const {
        cityName,
        cityCode: cityId,
        mobile,
        content,
        selDue: maternityDate,
        latitude,
        longitude,
        curDistrictId,
        curCityCode: curCityId
      } = this
      let regTel = /^[1][0-9]{10}$/
      if (isNullOrEmpty(mobile)) {
        this.errorTELText = '请输入手机号码，便于我们与您联系'
        // this.$$msgbox('请输入手机号码，便于我们与您联系')
        return false
      }
      if (
        !isNullOrEmpty(mobile) &&
        !regTel.test(mobile) &&
        !this.mobileEqualMaskMobile
      ) {
        this.errorTELText = '请输入正确手机号码'
        // this.$$msgbox('请输入正确手机号码')
        return false
      }
      this.clearErrTELTxt()
      const query = this.$route.query
      const sourceparam = query.sourceparam || '{}'
      const spObj = JSON.parse(decodeURI(sourceparam)) || {}
      const utm = spObj.canshu1 || ''
      //   const sourceid = query.sourceid || ''
      const formSource = 6
      const fuid = Cookie.get('uid') || ''
      //   this.trackClick(200002, undefined, `fuid: ${fuid}`)
      try {
        if (this.lockHttp) return
        this.lockHttp = true
        Indicator.open() //index.html 有style解决遮挡问题

        const param = {
          uid: fuid,
          cityId,
          cityName,
          maternityDate,
          content: content || '',
          mobile: mobile.includes('*') ? '' : mobile,
          utm,
          formSource,
          latitude,
          longitude,
          curDistrictId,
          curCityId,
          categoryName: '月嫂', //yuesao工程内的是“月嫂需求单”
          clueCategory: CLUE_CATEGORY.YUESAO,
          clueSource: CLUE_SOURE.ORDER_YUESAO
        }
        console.debug('11111', param)
        const resp = await fetch(
          PREFIX_SVSACTIVITY_API + 'appcustom/addWorkerIntention.do',
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            method: 'POST',
            body: queryString.stringify(param),
            credentials: 'include'
          }
        )
        const _res = await resp.json()

        if (_res && +_res.code === 1) {
          Indicator.close()
          this.$$toast('预约成功<br/>我们会尽快与您联系')
          const intentionId = _res.data
          this.removePersistenceItem()
          const params = {
            categorys: '月嫂', //yuesao工程内的是“月嫂需求单”
            utm,
            formType: 6,
            intentionId
          }
          this.$emit('submitSuccess') // HOME组件关闭弹框
          this.$emit('submit', params)
          this.reset()
        }
      } catch (e) {
        console.error(e)
        this.$$toast((e && e.msg) || '很抱歉，系统出问题了~')
      } finally {
        this.lockHttp = false
        Indicator.close()
      }
    },
    reset() {
      this.mobile = ''
      this.content = ''
      this.selDue = dueDates[1]
    },
    async getUserInfo() {
      let uid = Cookie.get('uid')
      let skey = Cookie.get('skey')
      if (uid && skey) {
        // 登陆
        const res = await getUserInfoApi(uid, skey)
        this.maskMobile = res?.data?.mobile ? res.data.mobile : ''
        this.mobile = this.maskMobile
        console.log(this.mobile, 'this.mobile')
      }
    }
  },
  computed: {
    mobileEqualMaskMobile() {
      return this.mobile == this.maskMobile
    }
  }
}
</script>
<style lang="scss" scoped src="./style.scss"></style>
